import { Box, Text } from "@mantine/core";

export const ALPHA_BANNER_HEIGHT = 18;

export function AlphaConstructionBanner() {
  return (
    <Box
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: ALPHA_BANNER_HEIGHT,
        zIndex: 5000,
        pointerEvents: "none",
        background:
          "repeating-linear-gradient(-45deg, #f59f00 0px, #f59f00 10px, #212529 10px, #212529 20px)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.45)",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.22)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Text
        fw={800}
        style={{
          fontSize: 10,
          color: "#ffffff",
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          textShadow:
            "0 1px 0 rgba(0, 0, 0, 0.95), 0 0 3px rgba(0, 0, 0, 0.8), 0 0 6px rgba(0, 0, 0, 0.6)",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "100%",
          padding: "0 8px",
          background: "#212529",
          border: "1px solid #343a40",
          borderRadius: 999,
          lineHeight: 1,
        }}
      >
        Alpha notice - under construction - data and features may change
      </Text>
    </Box>
  );
}
